/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class ModaltyRequest extends MainRequest {

    static addModality(data) {
        return this.postSEC(ServicePath.MODALTY_ADD, data)
    }

    static allModality() {
        return this.getSEC(ServicePath.MODALTY_LIST_ALL)
    }

    static updateModality(data) {
        return this.postSEC(ServicePath.MODALTY_UPDATE, data)
    }

    static deleteModalty(data) {
        return this.postSEC(ServicePath.MODALTY_DELETE, data)
    }

    static listModaltyBySpecialty(data) {
        return this.postSEC(ServicePath.MODALTY_LIST_BY_SPECIALITY, data)
    }

    static listModaltyByBranchOfficeAndSpecialty(data) {
        return this.postSEC(ServicePath.MODALTY_LIST_BY_BRANCH_OFFICE_AND_SPECIALITY, data)
    }

    static listModaltyByHumanResourceAndSpecialty(data) {
        return this.postSEC(ServicePath.MODALTY_LIST_BY_HUMAN_RESOURCE_AND_SPECIALITY, data)
    }

    static checkSpecialityByModality(data) {
        return this.postSEC(ServicePath.MODALITY_CHECK_SPECIALITY, data)
    }

}